export default __webpack_public_path__ + "static/media/valleyPort2.a33f2bc4.png";